import { Fragment } from "react";

// LDT-706 · Una frase traducida con enlaces dentro: «Acepto las {terms} y el
// {dpa}.» Cada `{clave}` se sustituye por su enlace, y el resto se pinta tal
// cual. Así la frase entera vive en el JSON de cada idioma (el orden de las
// palabras cambia entre castellano, catalán e inglés) en vez de trocearse en
// prefijo, enlace y sufijo. Las llaves simples no las toca i18next, que
// interpola con dobles.
//
// Los enlaces abren en otra pestaña: se leen a mitad de un formulario y
// navegar fuera lo perdería.

export interface LegalLink {
  href: string;
  label: string;
}

export function VenueLegalText({
  template,
  links,
  linkClassName,
}: {
  template: string;
  links: Record<string, LegalLink>;
  linkClassName?: string;
}) {
  const parts = template.split(/\{(\w+)\}/g);
  return (
    <>
      {parts.map((part, i) => {
        // split con un grupo: los impares son los nombres de las llaves.
        if (i % 2 === 0) return <Fragment key={i}>{part}</Fragment>;
        const link = links[part];
        if (!link) return <Fragment key={i}>{`{${part}}`}</Fragment>;
        return (
          <a key={i} href={link.href} target="_blank" rel="noopener noreferrer" className={linkClassName}>
            {link.label}
          </a>
        );
      })}
    </>
  );
}
